import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import { actorNames } from '../../../../commonComponents/utils'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'
import { isOperator } from '../../../../util'
import usePdiEnable from '../../../hooks/usePdiEnable'

export const Consignee = ({ renderForm }) => {

const {customJobState} = useCurrentShipmentType()

  const isPdi = customJobState?.includes('PDI')    
  const additionalFields = useCallback(
    ({
      updateActorFieldValue,
      saveActorDetails,
      id,
      actorType,
      translate,
      privateIndicatorFlag,
      disabled,
      disableFields,
      errorInfo,
    }) => {
      return isPdi ? (
        <Grid.Column width='3' className={`divFormFeild b-trr-5`}>
          <DropDown
            id={`${actorType}privateIndicatorFlag`}
            label={translate('PRIVATE OPERATOR', { ns: ['default', 'parties'] })}
            disabled={disabled || disableFields?.privateIndicatorFlag}
            errors={errorInfo?.[privateIndicatorFlag]}
            className='field-bg dropdown100'
            labelClass='text-none'
            isLabel={true}
            data={isOperator}
            value={privateIndicatorFlag}
            clearable
            direction='left'
            onChange={(value) => {
              updateActorFieldValue(actorType, { privateIndicatorFlag: value })
              saveActorDetails(
                { privateIndicatorFlag: value || ' ', id, actorType },
                'privateIndicatorFlag'
              )
            }}
          />
        </Grid.Column>
      ) : null
    },
    [customJobState]
  )

const pdiDisabled = usePdiEnable();


  const dataSource = useSelector((state) => state.Actor.consignee)
  return renderForm
    ? renderForm({
        actorType: 'consignee',
        boxNumber: '8',
        ...pdiDisabled,
        actorName: actorNames.consigneeName,
        dataSource: dataSource,
        firstRowFields: additionalFields,
      })
    : null
}
